import React from 'react';
import { View } from '@amzn/atoz-web/View';
export var ShiftCardScheduledStatus = function (_a) {
    var children = _a.children;
    return React.createElement(View, { dataTestId: "ShiftCardScheduledStatus" }, children);
};
